import { deleteItems, readItems } from '@directus/sdk';
import { useMutation } from '@tanstack/react-query';

import { notEmpty } from '../../../lib/notEmpty.ts';
import { directusClient } from '../../../services/directusClient/directusClient.ts';

export const useRemoveAllCurrentTargetAudiencesOfEventMutation = () => {
  return useMutation({
    mutationFn: async (eventId?: string) => {
      const eventsTargetAudiences = await directusClient.request(
        readItems('events_target_audiences', {
          filter: { events_id: { _eq: eventId } },
        }),
      );

      if (eventsTargetAudiences.length === 0) return;

      await directusClient.request(
        deleteItems('events_target_audiences', eventsTargetAudiences.map((item) => item.id).filter(notEmpty)),
      );
    },
  });
};
